import { Directive, ElementRef, HostListener } from '@angular/core';
import { replaceKeyPress } from './input-replace-keypress';

@Directive({
  selector: 'input[LowerCaseText]'
})
export class LowerCaseTextDirective {

  @HostListener('keypress', ['$event']) onKeyPress($event) {
    const key = $event.key;

    if (key.match(/^[A-Z]*$/)) {
      replaceKeyPress(this.ref.nativeElement, key.toLowerCase());
      $event.stopPropagation();
      return false;
    }

  }

  constructor(private ref: ElementRef) {
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/core/directives/lower-case-text.directive.ts